export function withSeparator(params: string[], separator: string = ' | '): string {
  return params.filter(Boolean).join(separator);
}
